import { useEffect, useRef, useState } from 'react';

import { IS_SYSTEM_THEME, USER_THEME, USER_THEME_DARK, USER_THEME_LIGHT } from 'constants/Constants';

import { getCurrentSystemTheme } from 'helpers/utils';

import { useCookies } from 'hooks/useCookies';

export const useThemeDetector = () => {
    const cookies = useCookies();

    const [theme, setTheme] = useState(cookies.get(USER_THEME));
    const [isSystemTheme, setIsSystemTheme] = useState(cookies.get(IS_SYSTEM_THEME) ?? true);

    const isSystemThemeRef = useRef();
    isSystemThemeRef.current = isSystemTheme;

    const setCurrentTheme = (theme, isSystemTheme) => {
        cookies.remove(USER_THEME, { path: '/' });
        cookies.set(USER_THEME, theme, { path: '/' });

        cookies.remove(IS_SYSTEM_THEME, { path: '/' });
        cookies.set(IS_SYSTEM_THEME, isSystemTheme, { path: '/' });
    };

    const onSystemThemeChange = (e) => {
        if (isSystemThemeRef.current !== true) {
            return;
        }

        const currentTheme = e.matches ? USER_THEME_DARK : USER_THEME_LIGHT;
        setCurrentTheme(currentTheme, true);
    };

    const onCookiesThemeChange = (e) => {
        if (e.name === USER_THEME && e.value !== undefined) {
            setTheme(e.value);
        }

        if (e.name === IS_SYSTEM_THEME && e.value !== undefined) {
            setIsSystemTheme(e.value);
        }
    };

    useEffect(() => {
        let darkThemeMedia;
        if (__isBrowser__ && window && window.matchMedia) {
            darkThemeMedia = window.matchMedia('(prefers-color-scheme: dark)');

            if (darkThemeMedia?.addEventListener) {
                darkThemeMedia?.addEventListener('change', onSystemThemeChange);
            } else {
                darkThemeMedia?.addListener(onSystemThemeChange);
            }

            cookies.addChangeListener(onCookiesThemeChange);

            if (isSystemThemeRef.current) {
                setCurrentTheme(getCurrentSystemTheme(), true);
            }
        }

        return () => {
            if (darkThemeMedia?.removeEventListener) {
                darkThemeMedia?.removeEventListener('change', onSystemThemeChange);
            } else {
                darkThemeMedia?.removeListener(onSystemThemeChange);
            }

            cookies.removeChangeListener(onCookiesThemeChange);
        };
    }, []);

    return { theme: theme ?? USER_THEME_LIGHT, setTheme: setCurrentTheme, isSystemTheme };
};
